import { COLORS, FONTS, TRACKING } from './tokens';

export const uppercaseHeading = {
  fontFamily: FONTS.heading,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: TRACKING.headline,
};

export const kicker = {
  fontFamily: FONTS.body,
  fontSize: 13,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: TRACKING.kicker,
  color: COLORS.accent,
};

export const cardBase = {
  background: COLORS.surface,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 8,
  padding: '28px 32px',
};

export const accentCard = (accentColor) => ({
  ...cardBase,
  borderLeft: `4px solid ${accentColor}`,
  borderLeftStyle: 'solid',
  borderLeftWidth: 4,
  borderLeftColor: accentColor,
});

export const darkCallout = {
  background: COLORS.navy,
  border: `1px solid ${COLORS.navy}`,
  borderRadius: 10,
  padding: '36px 40px',
  color: COLORS.white,
};

export const bodyText = {
  fontFamily: FONTS.body,
  fontSize: 15,
  lineHeight: 1.6,
  color: COLORS.textSecondary,
};

export const smallText = {
  fontFamily: FONTS.body,
  fontSize: 14,
  lineHeight: 1.55,
  color: COLORS.textMuted,
};

export const primaryButton = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: COLORS.accent,
  color: COLORS.white,
  fontFamily: FONTS.body,
  fontSize: 14,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: TRACKING.button,
  padding: '16px 40px',
  borderRadius: 4,
  border: 'none',
  cursor: 'pointer',
  boxShadow: '0 2px 8px rgba(37,47,106,0.25)',
  transition: 'transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
};

export const outlineButton = {
  ...primaryButton,
  background: 'transparent',
  color: COLORS.holidayBlue,
  border: `1.5px solid ${COLORS.holidayBlue}`,
  boxShadow: 'none',
};

export const inputField = {
  width: '100%',
  background: COLORS.white,
  border: `1.5px solid ${COLORS.border}`,
  borderRadius: 4,
  padding: '14px 16px',
  fontFamily: FONTS.body,
  fontSize: 15,
  color: COLORS.textPrimary,
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
};

export const pageShell = {
  minHeight: '100vh',
  width: '100%',
  background: COLORS.bgApp,
  fontFamily: FONTS.body,
  color: COLORS.textPrimary,
};

export const contentWrap = {
  maxWidth: 880,
  margin: '0 auto',
  padding: '0 20px',
};
